import nodeClient from "./node-client";

export const getPaymentModes = async (query = "") => {
  const response = await nodeClient.get(
    `/service/protected/v0/payment/mode/find?${encodeURI(query)}`
  );
  return response?.data.result;
};
